import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCodeBrackets: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconCodeBrackets"><Path d="M9.75 20.25L14.25 3.75M18.25 7.75L20.3787 9.87869C21.5503 11.0503 21.5503 12.9498 20.3787 14.1213L18.25 16.25M5.75 16.25L3.62133 14.1213C2.44975 12.9498 2.44975 11.0503 3.62132 9.87869L5.75 7.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconCodeBrackets;
